import { Link } from 'react-router-dom';
import { Seo } from '@/components/site/Seo';

export default function NotFound() {
  return (
    <section className="min-h-[70vh] flex items-center bg-brand-bone" data-testid="page-not-found">
      <Seo title="Page Not Found | HearthOak Construction" noindex path="/404" />
      <div className="container-x max-w-2xl">
        <div className="eyebrow mb-3">404</div>
        <h1 className="h1">This page could not be found.</h1>
        <p className="body-lg mt-5">The link may be old or the page may have moved. Try one of these instead:</p>
        <div className="mt-8 flex gap-3 flex-col sm:flex-row">
          <Link to="/" className="btn-primary">Back to home</Link>
          <Link to="/estimate" className="btn-secondary">Request an Estimate</Link>
        </div>
        <ul className="mt-8 space-y-2 font-sans text-sm">
          <li><Link to="/services" className="text-brand-maroon underline decoration-brand-maroon/40 underline-offset-4 hover:decoration-brand-maroon">Our services — drywall, painting, doors, trim & repairs</Link></li>
          <li><Link to="/service-areas" className="text-brand-maroon underline decoration-brand-maroon/40 underline-offset-4 hover:decoration-brand-maroon">Service areas — Fort Worth, Burleson, Weatherford, Granbury, Cleburne</Link></li>
          <li><Link to="/gallery" className="text-brand-maroon underline decoration-brand-maroon/40 underline-offset-4 hover:decoration-brand-maroon">Completed projects gallery</Link></li>
          <li><Link to="/blog" className="text-brand-maroon underline decoration-brand-maroon/40 underline-offset-4 hover:decoration-brand-maroon">Home repair articles</Link></li>
        </ul>
      </div>
    </section>
  );
}
